import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
import { cn } from "@/lib/utils";

// Сегменты по макету (компонент `segmented`): подложка #1F1F1F 3 % r96 pad 2
// gap 4, сегмент h36 pad 0/12 r96, Manrope 14/18 w500. Активный — заливка
// #1F1F1F, белый текст, мягкая тень; неактивный — без заливки, #1F1F1F 48 %.
// Примеры: «Актуальные заказы / Завершенные», «Ждут отзыва / Мои отзывы»,
// «Активные / Открыт спор / Архив».
type SegmentedOption<T extends string> = {
  value: T;
  label: React.ReactNode;
  disabled?: boolean;
};
type SegmentedProps<T extends string> = {
  options: readonly SegmentedOption<T>[];
  value: T;
  onValueChange: (value: T) => void;
  /** Растянуть сегменты поровну на всю ширину (как в модалках 408px). */
  block?: boolean;
  className?: string;
  "aria-label"?: string;
};
function Segmented(t0) {
  const $ = _c(16);
  const {
    options,
    value,
    onValueChange,
    block: t1,
    className,
    "aria-label": ariaLabel
  } = t0;
  const block = t1 === undefined ? false : t1;
  const t2 = block && "flex w-full max-w-none";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("inline-flex h-10 w-fit items-center gap-1 rounded-full bg-ds-field p-0.5", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== block || $[4] !== onValueChange || $[5] !== options || $[6] !== value) {
    let t5;
    if ($[8] !== block || $[9] !== onValueChange || $[10] !== value) {
      t5 = o => {
        const active = o.value === value;
        return <button key={o.value} type="button" role="tab" aria-selected={active} disabled={o.disabled} onClick={() => onValueChange(o.value)} className={cn("inline-flex h-9 cursor-pointer items-center justify-center whitespace-nowrap rounded-full px-3 text-[14px] leading-[18px] font-medium outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ds-focus disabled:cursor-not-allowed disabled:opacity-50", block && "flex-1", active ? "bg-ds-primary text-white shadow-[var(--ds-shadow-segment)]" : "text-ds-placeholder hover:text-ds-primary")}>{o.label}</button>;
      };
      $[8] = block;
      $[9] = onValueChange;
      $[10] = value;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = options.map(t5);
    $[3] = block;
    $[4] = onValueChange;
    $[5] = options;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[12] !== ariaLabel || $[13] !== t3 || $[14] !== t4) {
    t5 = <div role="tablist" aria-label={ariaLabel} data-slot="segmented" className={t3}>{t4}</div>;
    $[12] = ariaLabel;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
export { Segmented };
export type { SegmentedOption, SegmentedProps };